<template lang="pug">
	transition-expand
		.matrixFilters(v-show="active")
			matrix-filter(
				v-for="filter in data"
				:key="filter.tag",
				:id="id",
				:data="filter")
</template>

<script>
import Expand from "@/transitions/Expand";
import Filter from "./Filter";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MatrixFilters",
  props: ["data", "active", "id"],
  components: {
    matrixFilter: Filter,
    transitionExpand: Expand
  },
  computed: {
    ...mapGetters(["preFilters"])
  },
  methods: {
    ...mapMutations(["loadFilters"]),
    preSelect(filter) {
      let payload = {
        id: filter.id,
        tag: filter.data.tag,
        data: filter.data.values
      };
      this.loadFilters(payload);
    }
  },
  created() {
    if (this.preFilters) {
      let group = this.preFilters[this.id];
      if (group) {
        this.data.forEach(filter => {
          if (group.includes(filter.tag) || group.includes(filter.tag.toLowerCase()))
            this.preSelect({ id: this.id, data: filter });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.matrixFilters {
  display: flex;
  z-index: 5;
  flex-direction: column;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-y: auto;
  max-height: 200px;
  flex: 0 0 100%;
  padding: 0.5rem 1rem;
  margin: 0 -10px;
  min-width: calc(100% + 20px);
  order: 1;
  @media (min-width: 1100px) {
    position: absolute;
    padding: 0;
    top: 100%;
    left: -1px;
    right: -1px;
    margin: 0;
    background: $azure;
    order: initial;
		box-shadow: 
			6px 6px 12px rgba($black, 0.15), 
			-6px 6px 12px rgba($black, 0.15),
			18px 18px 26px rgba($black, 0.05), 
			-18px 18px 26px rgba($black, 0.05);
  }
}
</style>